import React, {Component} from 'react';
import {object} from 'prop-types';

import _ from 'lodash';

import Paper from '@material-ui/core/Paper';

import PanelHeader from '../../components/PanelHeader';

import AreaActionInsert from './AreaActionInsert';
import AreaItemActionInsert from './AreaItemActionInsert';
import CampusActionInsert from './CampusActionInsert';
import ClientActionInsert from './ClientActionInsert';
import EquipmentActionInsert from './EquipmentActionInsert';
import EquipmentItemActionInsert from './EquipmentItemActionInsert';
import SiteActionInsert from './SiteActionInsert';
import SystemActionInsert from './SystemActionInsert';
import SystemItemActionInsert from './SystemItemActionInsert';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import classes from './ActionPanel.module.css';

class ActionPanel extends Component {
    renderPanel = node => {
        const {
            companyInfo,
            currentScopes,
            onToggleCreateAreaModal,
            onToggleCreateAreaEquipmentModal,
            onToggleCreateCampusModal,
            onToggleCreateCampusSitesModal,
            onToggleCreateContactModal,
            onToggleCreateEquipmentModal,
            onToggleCreateEquipmentAreaModal,
            onToggleCreateEquipmentSystemModal,
            onToggleCreateSiteModal,
            onToggleCreateSystemModal,
            onToggleCreateSystemEquipmentModal,
            onToggleCreateSensorModal,
            onToggleDeleteAreaModal,
            onToggleDeleteCampusModal,
            onToggleDeleteClientModal,
            onToggleDeleteEquipmentModal,
            onToggleDeleteSiteModal,
            onToggleDeleteSystemModal,
            onToggleEditAreaModal,
            onToggleEditCampusModal,
            onToggleEditEntityModal,
            onToggleEditEquipmentModal,
            onToggleEditSiteModal,
            onToggleEditSystemModal,
            setTargetSite
        } = this.props;

        const isFullArchitectAllowed = isAllowed(currentScopes, Permissions('architectFull'));
        if (!isFullArchitectAllowed) {
            return (
                <p className={classes.emptyActions}>No actions available.</p>
            );
        }

        switch (node.type) {
            case 'area':
                return (
                    <AreaActionInsert
                        onToggleCreateAreaModal={onToggleCreateAreaModal}
                    />
                );
            case 'areaItem':
                return (
                    <AreaItemActionInsert
                        node={node}
                        onToggleCreateAreaEquipmentModal={onToggleCreateAreaEquipmentModal}
                        onToggleDeleteAreaModal={onToggleDeleteAreaModal}
                        onToggleEditAreaModal={onToggleEditAreaModal}
                    />
                );
            case 'campus':
                return (
                    <CampusActionInsert
                        node={node}
                        onToggleCreateCampusSitesModal={onToggleCreateCampusSitesModal}
                        onToggleCreateSiteModal={onToggleCreateSiteModal}
                        onToggleDeleteCampusModal={onToggleDeleteCampusModal}
                        onToggleEditCampusModal={onToggleEditCampusModal}
                    />
                );
            case 'client':
                return (
                    <ClientActionInsert
                        node={node}
                        onToggleCreateCampusModal={onToggleCreateCampusModal}
                        onToggleCreateContactModal={onToggleCreateContactModal}
                        onToggleCreateSiteModal={onToggleCreateSiteModal}
                        onToggleDeleteClientModal={onToggleDeleteClientModal}
                        onToggleEditEntityModal={onToggleEditEntityModal}
                    />
                );
            case 'equipment':
                return (
                    <EquipmentActionInsert
                        onToggleCreateEquipmentModal={onToggleCreateEquipmentModal}
                    />
                );
            case 'equipmentItem':
                return (
                    <EquipmentItemActionInsert
                        node={node}
                        onToggleCreateEquipmentAreaModal={onToggleCreateEquipmentAreaModal}
                        onToggleCreateEquipmentSystemModal={onToggleCreateEquipmentSystemModal}
                        onToggleCreateSensorModal={onToggleCreateSensorModal}
                        onToggleDeleteEquipmentModal={onToggleDeleteEquipmentModal}
                        onToggleEditEquipmentModal={onToggleEditEquipmentModal}
                    />
                );
            case 'sensor':
                return (
                    <p>Sensor Panel</p>
                );
            case 'site':
                return (
                    <SiteActionInsert
                        companyInfo={companyInfo}
                        node={node}
                        onToggleCreateAreaModal={onToggleCreateAreaModal}
                        onToggleCreateEquipmentModal={onToggleCreateEquipmentModal}
                        onToggleCreateSystemModal={onToggleCreateSystemModal}
                        onToggleDeleteSiteModal={onToggleDeleteSiteModal}
                        onToggleEditSiteModal={onToggleEditSiteModal}
                        setTargetSite={setTargetSite}
                    />
                );
            case 'system':
                return (
                    <SystemActionInsert
                        onToggleCreateSystemModal={onToggleCreateSystemModal}
                    />
                );
            case 'systemItem':
                return (
                    <SystemItemActionInsert
                        node={node}
                        onToggleCreateSensorModal={onToggleCreateSensorModal}
                        onToggleCreateSystemEquipmentModal={onToggleCreateSystemEquipmentModal}
                        onToggleDeleteSystemModal={onToggleDeleteSystemModal}
                        onToggleEditSystemModal={onToggleEditSystemModal}
                    />
                );
            default:
                return (
                    <p className={classes.emptyActions}>No actions available.</p>
                );
        }
    }

    prepareTitle = ({type}) => {
        if (type && _.isString(type)) {
            if (type.includes('Item')) {
                switch (type) {
                    case 'equipmentItem':
                        return 'Equipment Actions';
                    case 'areaItem':
                        return 'Area Actions';
                    case 'systemItem':
                        return 'System Actions';
                    default:
                        break;
                }
            }

            return `${type} Actions`;
        }

        return 'Actions Panel';
    }

    render() {
        const {node} = this.props;

        if (!node) return null;

        const title = this.prepareTitle(node);

        return (
            <Paper className={classes.ActionPanel}>
                <div className={classes.header}>
                    <PanelHeader
                        title={title}
                        url="/assets/images/agentActionsIconColor.svg"
                    />
                </div>
                {this.renderPanel(node)}
            </Paper>
        );
    }
}

ActionPanel.defaultProps = {
    node: {}
};

ActionPanel.propTypes = {
    node: object
};

export default ActionPanel;
